export const PRODUCTS_BINDING_CONTEXT_ID = 'commerce-products';
export const PRODUCTS_TEMPLATE_BINDING_CONTEXT_ID =
  'commerce-products-template';

export const CATEGORIES_BINDING_CONTEXT_ID = 'commerce-categories';
export const CATEGORIES_TEMPLATE_BINDING_CONTEXT_ID =
  'commerce-categories-template';

export const MORE_IMAGES_BINDING_CONTEXT_ID = 'commerce-more-images';
export const MORE_IMAGES_BINDING_CONTEXT_TYPE_ID = 'commerce-more-images-type';

export const fieldListBindingContextId = (fieldId: string) =>
  `f_list_${fieldId}`;

export const CART_BINDING_CONTEXT_TYPE_ID = 'commerce-cart-type';
export const CART_BINDING_CONTEXT_ID = 'commerce-cart';

export const SUBSCRIPTIONS_BINDING_CONTEXT_ID = 'commerce-subscriptions';
export const SUBSCRIPTIONS_BINDING_CONTEXT_TYPE_ID =
  'commerce-subscriptions-type';

export const CART_ITEMS_BINDING_CONTEXT_ID = 'commerce-cart-items';
export const CART_ITEM_PRODUCT_OPTIONS_BINDING_CONTEXT_ID =
  'commerce-cart-item-product-options';

export const PRODUCT_OPTION_BINDING_CONTEXT_TYPE_ID =
  'commerce-product-option-type';

export const ORDER_BINDING_CONTEXT_ID = 'commerce-order';
export const PAYPAL_ORDER_BINDING_CONTEXT_ID = 'commerce-paypal-order';
export const CONFIRMED_ORDER_BINDING_CONTEXT_ID = 'commerce-confirmed-order';

export const CHECKOUT_BINDING_CONTEXT_TYPE_ID = 'commerce-checkout-type';
export const PAYPAL_CHECKOUT_BINDING_CONTEXT_TYPE_ID =
  'commerce-paypal-checkout-type';
export const ORDER_CONFIRMATION_BINDING_CONTEXT_TYPE_ID =
  'commerce-order-confirmation-type';

export const ORDER_ITEMS_BINDING_CONTEXT = 'commerce-order-items';
export const ORDER_ITEM_BINDING_CONTEXT_TYPE_ID = 'commerce-cart-items';
export const ORDER_ITEM_PRODUCT_OPTIONS_BINDING_CONTEXT =
  'commerce-order-item-product-options';

export const ADD_TO_CART_OPTION_CONTEXT_ID = 'commerce-add-to-cart-option';
export const ADD_TO_CART_OPTION_CONTEXT_TYPE_ID =
  'commerce-add-to-cart-option-type';

export const CHECKOUT_PAGE_ROOT_CONTEXT_ID = 'commerce-checkout-page-root';
export const CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID =
  'commerce-checkout-page-root-type';

export const PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_ID =
  'commerce-paypal-checkout-page-root';
export const PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID =
  'commerce-paypal-checkout-page-root-type';

export const ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_ID =
  'commerce-order-confirmation-page-root';
export const ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_TYPE_ID =
  'commerce-order-confirmation-page-root-type';

export const SHIPPING_METHODS_BINDING_CONTEXT = 'commerce-shipping-methods';
export const SHIPPING_METHOD_BINDING_CONTEXT_TYPE_ID =
  'commerce-shipping-method-type';

export const EXTRA_ITEMS_BINDING_CONTEXT = 'commerce-extra-items';
export const EXTRA_ITEM_BINDING_CONTEXT_TYPE_ID = 'commerce-extra-item-type';

export const DOWNLOADS_BINDING_CONTEXT = 'commerce-downloads';
export const DOWNLOAD_BINDING_CONTEXT_TYPE_ID = 'commerce-download-type';
